/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import { reaction_like, reaction_celebrate, reaction_love, reaction_insightful, reaction_thinking, reaction_support } from "@assets/svg";
import { CommentComponentContextProps, CommentComponentProps, KnowledgeHubBookContextProps } from "@models/ui";
import React, { useContext, useEffect, useRef, useState } from "react";
import InputCommentComponent from "./input-comment.component";
import { classNames } from "@utilities";
import { CommentComponentContext, KhBookContext } from "../../kh-book-context";
import { BrowserCustomerClient } from "@client";
import { ResourceCommentReactionInputModel } from "@models/api";

interface ReactionsMapData {
    name: string;
    icon: string;
}

const reactionMapData: ReactionsMapData[] = [
    {
        name: "reaction_like",
        icon: reaction_like
    },
    {
        name: "reaction_celebrate",
        icon: reaction_celebrate
    },
    {
        name: "reaction_love",
        icon: reaction_love
    },
    {
        name: "reaction_insightful",
        icon: reaction_insightful
    },
    {
        name: "reaction_thinking",
        icon: reaction_thinking
    },
    {
        name: "reaction_support",
        icon: reaction_support
    },
];

const CommentComponent: React.FC<CommentComponentProps> = (commentComponentProps) => {

    const KhBookData = useContext<KnowledgeHubBookContextProps>(KhBookContext);
    const commentData = useContext<CommentComponentContextProps>(CommentComponentContext);

    const [isReactionsHovered, setIsReactionsHovered] = useState<boolean>(false);
    const [isReplyToCommentOpen, setIsReplyToCommentOpen] = useState<boolean>(false);
    const [isViewReplyOpen, setIsViewReplyOpen] = useState<boolean>(false);
    const inputRef = useRef<HTMLInputElement>(null);
    const [reactionImgSelected, setReactionImgSelected] = useState<string>("");
    const [reactionTextSelected, setReactionTextSelected] = useState<string>("");


    useEffect(() => {
        const handleReactionLoad = async () => {
            const client = new BrowserCustomerClient();
            const response = await client?.GetResourceCommentSelfReaction(commentData.comment.id);
            if (response?.success) {
                const respJson = response.data;
                // console.log("respJson :: ", respJson.comment);
                if (respJson.comment && respJson.comment !== "") {
                    setReactionTextSelected(respJson.comment);
                    setReactionImgSelected("reaction_" + respJson.comment);
                }
            }
        };

        if (!KhBookData.isLoggedIn) {
            return;
        }
        handleReactionLoad();
    }, []);

    const handleReactionHover = () => {
        setIsReactionsHovered(!isReactionsHovered);
    };

    const handleReplyClick = () => {
        if (!KhBookData.isLoggedIn) {
            commentComponentProps.handleCommentClick();
            return;
        }
        setIsReplyToCommentOpen(!isReplyToCommentOpen);
        setTimeout(() => {
            if (inputRef.current) {
                inputRef.current.focus(); // Focus on the input immediately
            }
        }, 0);
    }

    const handleViewReplyClick = () => {
        setIsViewReplyOpen(prevIsViewReplyOpen => !prevIsViewReplyOpen);
    }

    const handleReactionClick = async (reaction: string) => {
        if (!KhBookData.isLoggedIn) {
            commentComponentProps.handleCommentClick();
        }

        try {
            const client = new BrowserCustomerClient();

            if (reactionImgSelected === reaction) {
                //call api to delete
                const response = await client?.DeleteResourceCommentReaction(commentData.comment.id);
                if (response?.success) {
                    setReactionImgSelected("");
                    setReactionTextSelected("");
                }
                return;
            }

            let reactionText: string = "";
            if (reaction.includes("reaction_like"))
                reactionText = "like";
            else if (reaction.includes("reaction_celebrate"))
                reactionText = "celebrate";
            else if (reaction.includes("reaction_love"))
                reactionText = "love";
            else if (reaction.includes("reaction_insightful"))
                reactionText = "insightful";
            else if (reaction.includes("reaction_thinking"))
                reactionText = "thinking";
            else if (reaction.includes("reaction_support"))
                reactionText = "support";

            if (reactionTextSelected === "" && reactionImgSelected === "") {
                //call api to add 
                const data: ResourceCommentReactionInputModel = {
                    resourceCommentId: commentData.comment.id,
                    reaction: reactionText,
                }

                await client?.SaveResourceCommentReaction(data);
            } else {
                //call api to update
                const data: ResourceCommentReactionInputModel = {
                    resourceCommentId: commentData.comment.id,
                    reaction: reactionText,
                }

                await client?.UpdateResourceCommentReaction(data);
            }

            setReactionImgSelected(reaction);
            setReactionTextSelected(reactionText);
        } catch (error) {
            commentComponentProps.setIsCommentsPopupOpen(true);
        }
    }

    const getCommentClassName = () => {
        if (commentData.level === 0) {
            return "user-comment";
        }
        return "m-user-comment-reply"; //for mobile we want 52px of padding thus m-user-comment-reply insted of 56px of desktop
    };

    return (
        <>
            <div
                className={classNames("user-comment", getCommentClassName())}
                style={{ '--level': commentData.level } as React.CSSProperties}
            >
                <div className="user-content">
                    <div className="user-input">
                        <div className="input-text">
                            {
                                commentData.comment?.username_photo_url ?
                                    <img src={commentData.comment?.username_photo_url} alt="profile_pic" className="rounded-full w-[32px] h-[32px]" />
                                    :
                                    <div className="icon bg-[#004E98]">
                                        <p className="text ">{commentData.comment?.username[0]}</p>
                                    </div>
                            }

                            <div className="name-comment">
                                <div className="name-text">
                                    <div className="flex flex-col items-start">
                                        <p className="text"> {commentData.comment.username} </p>
                                        <p className="text-content"> {commentData.comment?.bio} </p>
                                    </div>
                                    <div className="number-text">
                                        <p className="text"> {commentData.comment.time} </p>
                                    </div>
                                </div>

                                <p className="text-para"> {commentData.comment.comment} </p>
                            </div>
                        </div>
                    </div>

                    <div className="react-reply-section relative">
                        <div className="react" onClick={handleReactionHover}>
                            {
                                reactionImgSelected === "" ?
                                    <>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none">
                                            <path d="M9.496 15.4292C9.224 15.5236 8.776 15.5236 8.504 15.4292C6.184 14.6506 1 11.4022 1 5.89663C1 3.46629 2.992 1.5 5.448 1.5C6.904 1.5 8.192 2.19214 9 3.2618C9.808 2.19214 11.104 1.5 12.552 1.5C15.008 1.5 17 3.46629 17 5.89663C17 11.4022 11.816 14.6506 9.496 15.4292Z" stroke="#625B70" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                        <p className="text-reply">React</p>
                                    </>
                                    :
                                    <>
                                        {
                                            (() => {
                                                let img_src = "";
                                                if (reactionTextSelected === "like") img_src = reaction_like;
                                                else if (reactionTextSelected === "celebrate") img_src = reaction_celebrate;
                                                else if (reactionTextSelected === "love") img_src = reaction_love;
                                                else if (reactionTextSelected === "insightful") img_src = reaction_insightful;
                                                else if (reactionTextSelected === "thinking") img_src = reaction_thinking;
                                                else if (reactionTextSelected === "support") img_src = reaction_support;

                                                const capReaction = reactionTextSelected?.charAt(0).toUpperCase() + reactionTextSelected?.slice(1);
                                                return (
                                                    <>
                                                        <img src={img_src} alt="reaction" />
                                                        <p className="text-reply">{capReaction}</p>
                                                    </>
                                                );
                                            })()
                                        }
                                    </>
                            }
                        </div>

                        {isReactionsHovered ? (
                            <div
                                className="react-action z-10 absolute -translate-x-4 -translate-y-10 transition duration-300 ease-in-out">
                                {reactionMapData.map((reaction, index) => (
                                    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
                                    <img
                                        key={index}
                                        src={reaction.icon}
                                        alt="reaction"
                                        className="relative transition-transform duration-200 transform hover:scale-150 hover:-translate-y-2 hover:z-20"
                                        onClick={() => handleReactionClick(reaction.name)}
                                    />
                                ))}
                            </div>
                        ) : null}

                        {
                            commentData.comment?.reactions && commentData.comment?.reactions?.length > 0 ?
                                <svg xmlns="http://www.w3.org/2000/svg" width="3" height="4" viewBox="0 0 3 4" fill="none">
                                    <path d="M3 2C3 2.82843 2.32843 3.5 1.5 3.5C0.671573 3.5 0 2.82843 0 2C0 1.17157 0.671573 0.5 1.5 0.5C2.32843 0.5 3 1.17157 3 2Z" fill="#565C65" />
                                </svg>
                                : ""
                        }

                        <button className="reactions" onClick={() => commentComponentProps.handlePopupToggle(commentData.comment.id)}>
                            <div className=" flex items-center -space-x-3">
                                {
                                    commentData.comment?.reactions ?
                                        commentData.comment?.reactions.map((reaction, index) => {
                                            let img_src = ""
                                            if (reaction === "like")
                                                img_src = reaction_like
                                            else if (reaction === "celebrate")
                                                img_src = reaction_celebrate
                                            else if (reaction === "love")
                                                img_src = reaction_love
                                            else if (reaction === "insightful")
                                                img_src = reaction_insightful
                                            else if (reaction === "thinking")
                                                img_src = reaction_thinking
                                            else if (reaction === "support")
                                                img_src = reaction_support
                                            return (
                                                <img key={index} src={img_src} alt="reaction" />
                                            )
                                        })
                                        : null
                                }
                            </div>
                            {
                                commentData.comment?.reactions?.length ?
                                    <p className="text-[#7A757F]"> {commentData.comment?.reactions.length} </p>
                                    : null
                            }
                        </button>

                        <svg xmlns="http://www.w3.org/2000/svg" width="3" height="4" viewBox="0 0 3 4" fill="none">
                            <path d="M3 2C3 2.82843 2.32843 3.5 1.5 3.5C0.671573 3.5 0 2.82843 0 2C0 1.17157 0.671573 0.5 1.5 0.5C2.32843 0.5 3 1.17157 3 2Z" fill="#565C65" />
                        </svg>

                        <div className="react" onClick={handleReplyClick}>
                            <p className="text-reply">Reply</p>
                        </div>
                    </div>

                    {isReplyToCommentOpen && (
                        <InputCommentComponent parentId={commentData.comment.id} setComments={commentComponentProps.setComments} handleReplyClick={handleReplyClick} handleCommentClick={commentComponentProps.handleCommentClick} setIsCommentsPopupOpen={commentComponentProps.setIsCommentsPopupOpen} />
                    )}

                    {
                        commentData.comment?.replies && commentData.comment?.replies?.length > 0 ?
                            <button className="reaction flex w-full justify-center" onClick={handleViewReplyClick}>
                                <p className="text-reply-one underline"> See {commentData.comment?.replies.length} more replies </p>
                            </button>
                            : null
                    }
                </div>
            </div>

            {
                isViewReplyOpen ?
                    <>
                        {commentData.comment?.replies ? commentData.comment?.replies.map((reply, index) => {
                            const commentNextData: CommentComponentContextProps = {
                                comment: reply,
                                level: commentData.level + 1,
                            }

                            return (
                                <CommentComponentContext.Provider value={commentNextData} key={index}>
                                    <CommentComponent handleCommentClick={commentComponentProps.handleCommentClick} setComments={commentComponentProps.setComments} handlePopupToggle={commentComponentProps.handlePopupToggle} handleReactionPopupClose={commentComponentProps.handleReactionPopupClose} setIsCommentsPopupOpen={commentComponentProps.setIsCommentsPopupOpen} />
                                </CommentComponentContext.Provider>
                            )
                        }) : ""}
                    </>
                    : ""
            }
        </>
    )
}

export default CommentComponent;
